"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleIframe = void 0;
const browser_1 = require("@augment-vir/browser");
const common_1 = require("@augment-vir/common");
const dimensions_1 = require("./augments/dimensions");
const duration_1 = require("./augments/duration");
const image_data_1 = require("./image-data");
const message_1 = require("./message");
function getIframeContentWindow(host) {
    var _a;
    return (_a = host.shadowRoot.querySelector('iframe')) === null || _a === void 0 ? void 0 : _a.contentWindow;
}
const maxContentWindowWaitTime = 60000;
async function handleIframe({ updateState, min, max, host, imageData, forcedFinalImageSize, forcedOriginalImageSize, }) {
    const startTime = Date.now();
    let trialAttempt = 0;
    while (!getIframeContentWindow(host)) {
        await (0, common_1.wait)((0, duration_1.makeAttemptWaitDuration)(trialAttempt));
        if (Date.now() - startTime > maxContentWindowWaitTime) {
            throw new Error(`Took over ${Math.floor(maxContentWindowWaitTime / 1000)} seconds for the vir-resizable-image iframe's content window to appear for '${imageData.imageUrl}'`);
        }
        trialAttempt++;
    }
    await (0, message_1.sendPingPongMessage)({
        message: {
            type: message_1.MessageType.Ready,
        },
        imageUrl: imageData.imageUrl,
        getMessageContext: () => { var _a; return (_a = getIframeContentWindow(host)) !== null && _a !== void 0 ? _a : undefined; },
    });
    if (forcedFinalImageSize) {
        await (0, message_1.sendPingPongMessage)({
            message: {
                type: message_1.MessageType.ForceSize,
                data: forcedFinalImageSize,
            },
            imageUrl: imageData.imageUrl,
            getMessageContext: () => { var _a; return (_a = getIframeContentWindow(host)) !== null && _a !== void 0 ? _a : undefined; },
        });
    }
    const imageDimensions = forcedOriginalImageSize !== null && forcedOriginalImageSize !== void 0 ? forcedOriginalImageSize : (await (0, message_1.sendPingPongMessage)({
        message: {
            type: message_1.MessageType.SendSize,
        },
        imageUrl: imageData.imageUrl,
        getMessageContext: () => { var _a; return (_a = getIframeContentWindow(host)) !== null && _a !== void 0 ? _a : undefined; },
        verifyData: (size) => {
            return !isNaN(size.width) && !isNaN(size.height) && !!size.width && !!size.height;
        },
    }));
    await handleLoadedImageSize({
        updateState,
        min,
        max,
        imageDimensions,
        host,
        imageData,
        forcedFinalImageSize,
    });
    return getIframeContentWindow(host).document.documentElement.outerHTML;
}
exports.handleIframe = handleIframe;
async function handleLoadedImageSize({ updateState, min, max, imageDimensions, host, imageData, forcedFinalImageSize, }) {
    const frameConstraintDiv = host.shadowRoot.querySelector('.frame-constraint');
    if (!(frameConstraintDiv instanceof HTMLElement)) {
        throw new Error(`Could not find frame constraint div.`);
    }
    const newImageSize = (0, dimensions_1.scaleToConstraints)({
        min,
        max,
        box: forcedFinalImageSize !== null && forcedFinalImageSize !== void 0 ? forcedFinalImageSize : imageDimensions,
    });
    frameConstraintDiv.style.width = (0, browser_1.addPx)(Math.floor(newImageSize.width));
    frameConstraintDiv.style.height = (0, browser_1.addPx)(Math.floor(newImageSize.height));
    const hostSize = (0, dimensions_1.clampDimensions)({
        min,
        max,
        box: newImageSize,
    });
    if (newImageSize.height < hostSize.height) {
        updateState({
            shouldVerticallyCenter: true,
        });
    }
    else {
        updateState({
            shouldVerticallyCenter: false,
        });
    }
    host.style.width = (0, browser_1.addPx)(hostSize.width);
    host.style.height = (0, browser_1.addPx)(hostSize.height);
    const ratio = (0, dimensions_1.calculateRatio)({
        min,
        max,
        box: forcedFinalImageSize !== null && forcedFinalImageSize !== void 0 ? forcedFinalImageSize : imageDimensions,
    });
    if (ratio > 3) {
        await (0, message_1.sendPingPongMessage)({
            message: {
                type: message_1.MessageType.SendScalingMethod,
                data: 'pixelated',
            },
            imageUrl: imageData.imageUrl,
            getMessageContext: () => { var _a; return (_a = getIframeContentWindow(host)) !== null && _a !== void 0 ? _a : undefined; },
        });
    }
    else {
        await (0, message_1.sendPingPongMessage)({
            message: {
                type: message_1.MessageType.SendScalingMethod,
                data: 'default',
            },
            imageUrl: imageData.imageUrl,
            getMessageContext: () => { var _a; return (_a = getIframeContentWindow(host)) !== null && _a !== void 0 ? _a : undefined; },
        });
    }
    if (imageData.imageType === image_data_1.ImageType.Html) {
        const forcedScales = forcedFinalImageSize
            ? {
                width: forcedFinalImageSize.width / imageDimensions.width,
                height: forcedFinalImageSize.height / imageDimensions.height,
            }
            : {
                width: 1,
                height: 1,
            };
        const scales = {
            width: ratio * forcedScales.width,
            height: ratio * forcedScales.height,
        };
        await (0, message_1.sendPingPongMessage)({
            message: {
                type: message_1.MessageType.SendScale,
                data: scales,
            },
            imageUrl: imageData.imageUrl,
            getMessageContext: () => { var _a; return (_a = getIframeContentWindow(host)) !== null && _a !== void 0 ? _a : undefined; },
        });
    }
}
